module.exports = __webpack_public_path__ + "assets/img/spjy.0e5db5eb.jpg";